module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-16.95362118.png";